import { z } from 'zod';
import { premiumStatus } from './i18n.js';

export const registerBody = z.object({
  email: z.email(),
  password: z.string().min(8).max(200),
  inviteCode: z.string().optional(),
});
export type RegisterBody = z.infer<typeof registerBody>;

export const loginBody = z.object({
  email: z.email(),
  password: z.string().min(1),
});
export type LoginBody = z.infer<typeof loginBody>;

export const userDto = z.object({
  id: z.uuid(),
  email: z.email(),
  createdAt: z.string(),
  premium: premiumStatus,
  // e-mail is listed in ADMIN_EMAILS → may open /admin
  isAdmin: z.boolean(),
});
export type UserDto = z.infer<typeof userDto>;

export const changePasswordBody = z.object({
  currentPassword: z.string().min(1),
  newPassword: z.string().min(8).max(200),
});
export type ChangePasswordBody = z.infer<typeof changePasswordBody>;

// Public: the client needs to know whether to show "sign up" and the invite-code field
export const registrationMode = z.enum(['open', 'invite_code', 'closed']);
export type RegistrationMode = z.infer<typeof registrationMode>;
export const registrationModeResponse = z.object({ mode: registrationMode });
export type RegistrationModeResponse = z.infer<typeof registrationModeResponse>;

// Personal invite code of the signed-in user (GET /api/invites)
export const inviteInfo = z.object({
  code: z.string(),
  used: z.number().int(),
  max: z.number().int(),
  // registration link with the code prefilled
  link: z.string(),
});
export type InviteInfo = z.infer<typeof inviteInfo>;
